import { Spacing1Icon, styled } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

const VerticalSpaceAround = styled(Spacing1Icon)`
  transform: rotate(90deg);
`;

interface Props {
  justifyContent?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
}

export const JustifySpaceAround = ({ justifyContent, flexDirection, toggleValues }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-justify"
      id="justify-space-around"
      data-cy="toolbox-flex-justify-space-around"
      onClick={() =>
        toggleValues({
          justifyContent: 'space-around',
        })
      }
      isActive={justifyContent === 'space-around'}
      icon={flexDirection === 'row' ? Spacing1Icon : VerticalSpaceAround}
      tooltip="Space around"
      color="light"
    />
  );
};
